export const Column = {
  DATA_COLLECTION: 'Data Collection',
  ADJUSTMENT: 'Adjustment',
  ADJUSTMENTS: 'Adjustments',
  TOTAL: 'Total',
};
